export default function formatBytes(bytes,decimals) {
  if (bytes === 0) return '0 Bytes'
  let k = 1024,
      dm = decimals || 2,
      sizes = ['B', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb'],
      i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
